import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Layout, Result } from 'antd'
import { useParams, useLocation } from 'react-router-dom'
import {
	SmileOutlined,
	AlertOutlined,
	DownloadOutlined,
} from '@ant-design/icons'
import { createContractExternal } from '~/states/modules/externalContract'

import DocumentForm from 'components/documentForm'

import {
	verifyToken,
	storeURLVariables,
} from '~/states/modules/externalContract'
import { getTemplateDetail } from 'states/modules/editTemplate'
import { listQuestion } from 'states/modules/question'
import UploadDocumentModal from './components/uploadDocumentModal'
import { useHistory } from 'react-router-dom'
import {
	downloadTextDocumentVersion,
	getDocumentWordDownload,
} from 'states/modules/documentDetail'
import { errorMessage } from 'services/messager'

const AddContractExternal = () => {
	const { token } = useParams()
	const { search } = useLocation()
	const external_id = useRef(null)
	const external_title = useRef(null)
	const external_user = useRef(null)
	const searchParams = new URLSearchParams(search)
	const [showUploadModal, setShowUploadModal] = useState(false)
	const [isFinishing, setIsFinishing] = useState(false)

	const history = useHistory()
	const dispatch = useDispatch()
	const {
		data,
		loading,
		created,
		authorized,
		filledVars,
		createdDocumentData,
	} = useSelector(({ externalContract }) => externalContract)

	const {
		textDocumentVersion: { loading: loadingTextDownload },
		loading: loadingDocxDownload,
	} = useSelector(({ documentDetail }) => documentDetail)
	const session = useSelector(({ session }) => session)
	const hasDemands = session?.company?.config?.has_demands

	const getMessage = (success) => (
		<>
			<Result
				status={success ? 'success' : 'warning'}
				icon={success ? <SmileOutlined /> : <AlertOutlined />}
				title={
					success
						? 'Seu documento foi criado com sucesso!'
						: 'Atenção! Documento já foi criado!'
				}
				subTitle={
					success
						? 'Agora você pode baixar o documento e abrir uma nova demanda para o Jurídico'
						: null
				}
			/>
			{success && (
				<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
					<Button
						onClick={handleDownloadDocDifTypes}
						icon={<DownloadOutlined />}
						style={{ width: 180, alignSelf: 'center' }}
						loading={loadingTextDownload || loadingDocxDownload}
						disabled={loadingTextDownload || loadingDocxDownload}>
						Baixar documento
					</Button>
					{hasDemands && (
						<Button
							onClick={() => history.push('/demands/new')}
							style={{ width: '180px', alignSelf: 'center' }}
							type="primary">
							Abrir nova demanda
						</Button>
					)}
				</div>
			)}
		</>
	)

	const handleDownloadDocDifTypes = (event) => {
		try {
			if (createdDocumentData.text_type === '.txt') {
				if (createdDocumentData !== undefined) {
					downloadVersionHandler(event, createdDocumentData.versions[0])
				}
			} else {
				getDocumentWord()
			}
		} catch (error) {
			console.log(error)
			errorMessage({
				content: 'Não foi possível realizar baixar o documento.',
			})
		}
	}

	const downloadVersionHandler = (event, item) => {
		event.stopPropagation()
		const versionInfo = {
			id: createdDocumentData.id,
			versionId: item.id,
			versionName: item.description,
			documentTitle: createdDocumentData.title,
			companyId: createdDocumentData.company_id,
			downloadFormat: createdDocumentData.download_format,
		}
		dispatch(downloadTextDocumentVersion(versionInfo))
	}

	const getDocumentWord = () => {
		dispatch(
			getDocumentWordDownload({
				id: createdDocumentData.id,
				filename: `${createdDocumentData.title}.docx`,
			})
		)
	}

	useEffect(() => {
		const variables = {}
		for (const [key, value] of searchParams) {
			if (key === 'external_id') {
				external_id.current = value
			} else if (key === 'title') {
				external_title.current = value
			} else if (key === 'user') {
				external_user.current = value
			} else {
				variables[key] = value
			}
		}
		dispatch(storeURLVariables({ variables }))
		// eslint-disable-next-line
	}, [dispatch])

	useEffect(() => {
		dispatch(verifyToken({ token }))
	}, [dispatch, token])

	useEffect(() => {
		if (!loading && data && data?.Template?.text_type === 'upload') {
			setShowUploadModal(true)
		}
	}, [loading, data])

	useEffect(() => {
		if (!loading && data?.Template && authorized) {
			dispatch(
				listQuestion({
					modelId: data.Template.id,
					documentTitle: `${data.name} - ${data.config.counter}`,
					parent: undefined,
					isExternal: true,
				})
			)
		}
	}, [data, loading, dispatch])

	const handleFinish = useCallback(
		(draft) => {
			setIsFinishing(true)
			dispatch(
				createContractExternal({
					token,
					external_id: external_id.current,
					title: external_title.current,
					external_user: external_user.current,
					draft,
				})
			)
		},
		[dispatch, token]
	)
	return authorized && !created ? (
		<>
			<DocumentForm
				onFinish={handleFinish}
				initialValues={filledVars}
				cancelRoute={'/'}
				allowDraft={false}
				hasPreview={data.config?.hasPreview}
				isFinishing={isFinishing}
				isExternal={true}
				templateId={data?.Template?.id}
			/>
			<UploadDocumentModal
				showModal={showUploadModal}
				onClose={() => setShowUploadModal(false)}
			/>
		</>
	) : (
		<Layout style={{ backgroundColor: '#fff' }}>{getMessage(created)}</Layout>
	)
}

export default AddContractExternal
